export enum QuoteVehicleUseTypes {
  Private = 1,
  Business = 2,
}
